/**
 * Filters and sanitizes an HTML string.
 * - Modifies all tags not in the allowed list.
 * - Escapes stray angle brackets.
 * - Replaces special characters with HTML entities.
 * - Removes script/style tags and event handlers.
 * - Normalizes whitespace.
 * - Converts <p> to <div>.
 */

export function filterHtmlString(input: string): string {
  const allowedTags = [
    "div", "li", "ul", "ol", "h1", "h2", "h3", "h4", "caption", "table", "thead", "tr", "th", "td", "tbody", "img", "a", "u", "s", "em", "strong", "span", "b", "br", "i", "sup", "acronym"
  ];

  // Remove script/style tags and event handlers for security
  input = input.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "");
  input = input.replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, "");
  input = input.replace(/\son\w+="[^"]*"/gi, "");

  // Convert <p> to <div>
  input = input.replace(/<p/g, "<div").replace(/<\/p/g, "</div");

  // Replace special characters
  input = input.replace(/≤/g, "&le;").replace(/≥/g, "&ge;");

  // Escape any <tag ...> or </tag ...> where tag is not whitelisted
  input = input.replace(/<(\/?)([a-zA-Z0-9]+)([^>]*)>/g, (match, slash, tag) => {
    return allowedTags.includes(tag.toLowerCase())
      ? match
      : match.replace('<', '&lt;');
  });

  // Normalize whitespace
  input = input.replace(/\s+/g, " ");

  return input;
}

// original simplified solution

// export function filterHtmlString(input: string): string {
//   // Only escape < that starts a tag with invalid characters (not a-z, A-Z, 0-9, /)
//   // This prevents errors like <loq" from being interpreted as a tag
//   return input.replace(/<([^\w\/!])/g, "&lt;$1");
// }